import { useMutation } from "@tanstack/react-query";
import {
	postChatAdd,
	postChatAddFirst,
} from "web_myplann/Infrastructure/ApiOld/Api";

type SendMessageVariables = {
	conversationId: number | null;
	advisorId?: string;
	content: string;
};

export const useSendMessageMutation = () =>
	useMutation({
		mutationFn: async ({
			conversationId,
			advisorId,
			content,
		}: SendMessageVariables) => {
			const response =
				conversationId !== null
					? await postChatAdd({ conversationId, content })
					: await postChatAddFirst({
							advisorIds: advisorId ? [advisorId] : [],
							content,
						});

			if (response.status !== 200) {
				throw new Error("Failed to send message");
			}

			return response.data.data.item;
		},
	});
